import { Link, useNavigate, useLocation } from "react-router-dom";
import { ImagePath } from "../../assets/images/menu-icon/helper";
import { useEffect, useState } from "react";
import WebService from "../../Services/WebService";
import { Placeholder } from "react-bootstrap";
import { toast } from "react-toastify";

interface PropData {
  isToggle: boolean;
}

const VerticalMenu = ({ isToggle }: PropData) => {
  const [menus, setMenus] = useState<any[]>([]);
  const [loader, setLoader] = useState(false);
  const [activeMenu, setActiveMenu] = useState(
    localStorage.getItem("active_menu") ?? "Dashboard"
  );

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const cachedMenus = localStorage.getItem("menus");
    if (cachedMenus) {
      const parsedMenus = JSON.parse(cachedMenus);
      setMenus(parsedMenus);

      // Only navigate once after login (not on browser back)
      const hasNavigated = sessionStorage.getItem("hasNavigatedToFirstMenu");
      if (!hasNavigated && parsedMenus.length > 0) {
        navigate(parsedMenus[0].url);
        sessionStorage.setItem("hasNavigatedToFirstMenu", "true");
      }
    } else {
      fetchMenus();
    }
  }, []);

 useEffect(() => {
  const currentPath = location.pathname;
  const matchedMenu = menus.find((menu) => menu.url === currentPath);
  if (matchedMenu && matchedMenu.name !== activeMenu) {
    setActiveMenu(matchedMenu.name);
    localStorage.setItem("active_menu", matchedMenu.name);
  }
}, [location.pathname, menus, activeMenu]);

  const fetchMenus = async () => {
    setLoader(true);
    try {
      const res: any = await WebService.CommonApi({
        method: "GET",
        action: `left-menus`,
        body: null,
        isShowError: true,
      });

      if (res.list.length > 0) {
        setMenus(res.list);
        localStorage.setItem("menus", JSON.stringify(res.list));

        const hasNavigated = sessionStorage.getItem("hasNavigatedToFirstMenu");
        if (!hasNavigated) {
          navigate(res.list[0].url);
          sessionStorage.setItem("hasNavigatedToFirstMenu", "true");
        }
      }
    } catch (error: any) {
      console.error("Menu Fetch Error:", error);
      toast.error(error?.response?.data?.message || "Failed to fetch menus");
    } finally {
      setLoader(false);
    }
  };

  const handleMenuClick = (menu: any) => {
    localStorage.setItem("property_detail_tab", "tab1");
    localStorage.setItem("tabId", "tab1");
    localStorage.setItem("active_menu", menu.name);
    setActiveMenu(menu.name);
  };

  return (
    <div
      id="vertical_menu"
      className={`verticle-menu ${isToggle ? "open-menu" : ""}`}
    >
      <div className="menu-list position-relative">
        {loader ? (
          <div className="px-3 menu-placeholder">
            {[...Array(10)].map((_, index) => (
              <Placeholder key={index} xs={12} />
            ))}
          </div>
        ) : (
          menus.map((menu, index) => (
            <Link
              key={index}
              to={menu.url}
              onClick={() => handleMenuClick(menu)}
              className={`menu-item ${
                activeMenu === menu.name ? "active" : ""
              }`}
            >
              <img
                src={ImagePath(menu.icon_class)}
                alt=""
                className="menu-icon"
              />
              <span className="nav-text">{menu.name}</span>
            </Link>
          ))
        )}
      </div>
    </div>
  );
};

export default VerticalMenu;
